import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from '../..';

import { ConfirmationRequestViewModel, AutoAuthoViewModel } from '@services/AutoAuthoService';

import { AutoAuthoComponent, AutoAuthoComponentProperties, AutoAuthoPage } from './auto-autho.component';
import { authorize, getSwoTripStatuses, getViewModel, gotoPage, updateViewModel } from '../auto-autho.actions';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<AutoAuthoComponentProperties> {
  return {
    authorizationResult: state.autoAutho.authorizationResult,
    hasConfirmationFailed: state.autoAutho.hasConfirmationFailed,
    page: state.autoAutho.page,
    phoneNumber: state.autoAutho.phoneNumber,
    swoId: state.autoAutho.swoId,
    swoTripStatusMap: state.autoAutho.swoTripStatusMap,
    viewModel: state.autoAutho.viewModel
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<AutoAuthoComponentProperties> {
  return {
    authorize: (phoneNumber: string, swoId: number, request: ConfirmationRequestViewModel) =>
      dispatch(authorize(phoneNumber, swoId, request)),
    getViewModel: (phoneNumber: string, swoId: number, rememberPhoneNumber: boolean) =>
      dispatch(getViewModel(phoneNumber, swoId, rememberPhoneNumber)),
    getSwoStatusMap: (phoneNumber: string, swoId: number) => dispatch(getSwoTripStatuses(phoneNumber, swoId)),
    gotoPage: (page: AutoAuthoPage) => dispatch(gotoPage(page)),
    updateViewModel: (viewModel: AutoAuthoViewModel) => dispatch(updateViewModel(viewModel))
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const AutoAutho = connect(
  mapStateToProps,
  mapDispatchToProps
)(AutoAuthoComponent);



// WEBPACK FOOTER //
// ./src/auto-autho/_components/auto-autho.container.ts